module.exports = __webpack_public_path__ + "img/Jump Casting93.248a24a4.jpg";